// extracted by mini-css-extract-plugin
module.exports = {"message":"style_message__195EZ","icon":"style_icon__TbsTh","title":"style_title__-o0vY"};